const a=({spacing:r,typography:t})=>({styleOverrides:{root:{...t.h6,padding:r(1),backgroundColor:"transparent"}},defaultProps:{disableGutters:!0}});export{a as default};
